import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProcessLoaderIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0ZM15 4.41211C9.15255 4.4123 4.4123 9.15255 4.41211 15C4.41211 20.8476 9.15244 25.5887 15 25.5889C20.8477 25.5889 25.5889 20.8477 25.5889 15C25.5887 9.15244 20.8476 4.41211 15 4.41211Z",
		fill: "#BDD2E7"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13.3533 0.0906479C15.8969 -0.19025 18.47 0.184235 20.8279 1.17854C22.505 1.88575 24.0337 2.88972 25.3432 4.1364C26.2265 4.97737 26.0453 6.3795 25.0836 7.12963C24.1229 7.87905 22.7483 7.68622 21.8167 6.90083C19.9751 5.34822 17.5972 4.41194 14.9998 4.41194C9.15237 4.41212 4.41211 9.15238 4.41193 14.9998C4.41193 20.8474 9.15226 25.5885 14.9998 25.5887C15.1326 25.5887 15.2425 25.6894 15.2455 25.8221L15.2903 27.7882C15.3181 29.0075 14.3473 30.0351 13.1372 29.8837C11.3431 29.6591 9.59816 29.1112 7.98908 28.2606C5.72688 27.0646 3.80842 25.3097 2.41583 23.1629C1.02323 21.016 0.202791 18.5483 0.0330213 15.9949C-0.136703 13.4415 0.349857 10.8865 1.44611 8.57405C2.54236 6.26175 4.21159 4.26792 6.29572 2.78303C8.37993 1.29809 10.8097 0.371562 13.3533 0.0906479Z",
		fill: "white"
	})]
});
export default SvgProcessLoaderIcon;
